WB.DataManagers = WB.DataManagers || {};
WB.DataManagers.Popup = function ($q, _User, _AppData, PopupDataService, DataManagerUtility) {

    ['Popups'].forEach(function(key) {
        if (_AppData[key]) {
            var sig = _AppData[key][0].Type + ':' + _AppData[key][0].Id;
            if (_AppData[key][0].Type === 'Photo') {
                sig = _AppData[key][0].Type + ':' + _AppData[key][0].Id + ':' + _AppData[key][0].Tags.join(',');
            }
            DataManagerUtility.SetCache({
                name: key,
                signature: sig,
                value: $q(function(resolve, reject) {
                    resolve(_AppData[key][0]);
                })
            });
        }
    });

    this.GetPopupByTypeAndId = function(options) {
        var sig = options.type + ':' + options.id;
        var resolver = DataManagerUtility.GetCache({
            name: 'Popups',
            signature: sig
        });

        if (resolver) {
            return resolver;
        } else {
            var newCache = {
                name: 'Popups',
                signature: sig,
                value: PopupDataService.GetPopupByTypeAndId(options)
            };
            DataManagerUtility.SetCache(newCache);
            newCache.value.catch(function(err) {
                DataManagerUtility.ClearCache({ name: 'Popups', signature: sig });
            });
            return newCache.value;
        }
    };
};
WB.DataManagers.Popup.$inject = ['$q', '_User', '_AppData', 'PopupDataService', 'DataManagerUtility'];

WB.Core.service('PopupDataManager', WB.DataManagers.Popup);